(function () {
    let freeGiftOverrideInstalled = false;
    let progressBarOverrideInstalled = false;

    function installFreeGiftOverride() {
        if (freeGiftOverrideInstalled) return;

        if (window.tlFreeGiftOffer && typeof window.tlFreeGiftOffer.detectCartData === 'function') {
            window.tlFreeGiftOffer.detectCartData = async function () {
                try {
                    const cartData = await this.ajaxApi.cartGet();

                    const itemsInCart = new Map();
                    const ruleIdMapGifts = new Map();
                    if (cartData.items.length) {
                        const validItem = cartData.items.find(item => !isNaN(item.price / item.presentment_price));
                        const ratio = validItem ? validItem.price / validItem.presentment_price : 1;

                        for (let i = 0; i < cartData.items.length; i++) {
                            const item = cartData.items[i];
                                
                            const itemKey = item.key;
                            const itemId = String(item.id);
                            const productId = String(item.product_id);
        
                            const appliedRuleId = this.checkLineItemIsGift(item);

                            if (appliedRuleId) {
                                const giftsOfRule = ruleIdMapGifts.get(appliedRuleId) ?? [];
                                ruleIdMapGifts.set(appliedRuleId, [...giftsOfRule, {
                                    id: itemId,
                                    key: itemKey,
                                    quantity: item.quantity,
                                    price: (item.final_price ?? item.price) / ratio // Đổi sang final_price
                                }]);
                            } else if (!this.utils.isOtherModuleGift(item)) { // Giữ điều kiện kiểm tra quà module khác
                                itemsInCart.set(itemKey, {
                                    id: itemId,
                                    price: (item.final_price ?? item.price) / ratio, // Đổi sang final_price
                                    quantity: item.quantity,
                                    title: item.title,
                                    image: item.image,
                                    productId: productId,
                                    selling_plan: !!item.selling_plan_allocation
                                });
                            }
                        }
                    }

                    this.itemsInCart = new Map(itemsInCart);
                    this.ruleIdMapGifts = new Map(ruleIdMapGifts);
                    
                    // Clear temp cart
                    this.itemsInTempCart.clear();
                    this.ruleIdMapGiftsInTempCart.clear();
                } catch (error) {
                    console.log("Error when overridden detectCartData (Free Gift): ", error);
                }
            };

            freeGiftOverrideInstalled = true;
            console.log("Salepify Free Gift - Sale Price Override Installed Successfully.");

            // Gọi updateCartData ngay lập tức để tính lại điều kiện và re-render widget Gift in Cart
            if (typeof window.tlFreeGiftOffer.updateCartData === 'function') {
                window.tlFreeGiftOffer.updateCartData();
            }
        }
    }

    function installProgressBarOverride() {
        if (progressBarOverrideInstalled) return;

        if (window.tlCartGoalEmbed) {
            try {
                // Thay thế logic tính giá để lấy giá sau giảm (final_line_price thay vì line_price)
                window.tlCartGoalEmbed.getItemPrice = function(item) {
                    return window.tlCartGoalEmbed.isCalcByDiscountedPrice
                        ? (item.final_line_price ?? item.line_price)
                        : item.original_line_price;
                };

                // Cập nhật luôn cho logic lấy giá subtotal trước order discount
                window.tlCartGoalEmbed.getSubtotalBeforeOrderDiscountItemPrice = function(item) {
                    return item.final_line_price ?? item.line_price;
                };

                progressBarOverrideInstalled = true;
                console.log("Salepify Progress Bar - Sale Price Override Installed Successfully.");

                // Render lại progress bar để cập nhật dữ liệu cart
                if (typeof window.tlCartGoalEmbed.renderAllCartGoals === 'function') {
                    window.tlCartGoalEmbed.renderAllCartGoals();
                }
            } catch (error) {
                console.log("Error when overridden tlCartGoalEmbed (Progress Bar): ", error);
            }
        }
    }

    function initOverrides() {
        installFreeGiftOverride();
        installProgressBarOverride();
    }

    initOverrides();

    // Tiếp tục thử override nếu một trong hai chưa được cài đặt (trường hợp load script bị chậm)
    if (!freeGiftOverrideInstalled || !progressBarOverrideInstalled) {
        let attempts = 0;
        const interval = setInterval(() => {
            attempts++;
            initOverrides();
            if ((freeGiftOverrideInstalled && progressBarOverrideInstalled) || attempts > 50) {
                clearInterval(interval);
            }
        }, 100);
    }
})();